export default __webpack_public_path__ + "static/biodiversity-3b7d3074ac9ef037fae6bac0927d958f.webp";